import React from 'react';
import { createPortal } from 'react-dom';

const STATUS_LABELS = {
  queued: 'En cola',
  processing: 'Procesando',
  completed: 'Completado',
  failed: 'Error',
};

const ExportProgressModal = ({
  isOpen,
  title = 'Generando archivo',
  progress,
  onClose,
  allowClose = false,
  queuedMessage = 'Reporte amplio: la generación corre en segundo plano. Si no avanza, verifique que el worker de colas esté activo.',
  defaultMessage = 'Generando el archivo…',
  itemsLabel = 'Filas procesadas',
  statusLabels = null,
}) => {
  if (!isOpen) return null;

  const pct = Math.min(100, Math.max(0, Number(progress?.progress_percent) || 0));
  const status = progress?.status || 'processing';
  const itemsProcessed = progress?.items_processed;
  const itemsTotal = progress?.items_total;
  const showItems = Number(itemsTotal) > 0 && progress?.phase === 'background';

  const modal = (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/50"
      style={{ whiteSpace: 'normal' }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="export-progress-title"
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full min-w-0 border border-gray-200"
        style={{ maxWidth: '28rem', whiteSpace: 'normal' }}
      >
        <div className="px-5 py-4 border-b border-gray-200">
          <h3 id="export-progress-title" className="text-lg font-semibold text-gray-900 break-words" style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
            {title}
          </h3>
          <p
            className="text-sm text-gray-500 mt-1 break-words"
            style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}
          >
            {progress?.message || defaultMessage}
          </p>
        </div>
        <div className="px-5 py-5 space-y-3">
          <div className="flex items-center justify-between text-xs text-gray-600">
            <span>{(statusLabels || STATUS_LABELS)[status] || 'Procesando'}</span>
            <span className="font-mono tabular-nums">{pct}%</span>
          </div>
          <div className="h-2.5 w-full rounded-full bg-gray-100 overflow-hidden">
            <div
              className={`h-full transition-all duration-300 ease-out ${status === 'failed' ? 'bg-red-500' : 'bg-teal-600'}`}
              style={{ width: `${pct}%` }}
            />
          </div>
          {showItems ? (
            <p
              className="text-xs text-gray-500 break-words"
              style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}
            >
              {itemsLabel}{' '}
              <span className="font-mono text-gray-700">
                {itemsProcessed ?? 0} / {itemsTotal}
              </span>
            </p>
          ) : null}
          {status === 'queued' ? (
            <p
              className="text-xs text-amber-700 bg-amber-50 border border-amber-100 rounded-md px-3 py-2 break-words"
              style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}
            >
              {queuedMessage}
            </p>
          ) : null}
        </div>
        {allowClose ? (
          <div className="px-5 py-4 border-t border-gray-200 bg-gray-50 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Cerrar
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );

  if (typeof document === 'undefined') return modal;

  return createPortal(modal, document.body);
};

export default ExportProgressModal;
